import {DateRangeFilter} from "components/_defaultComponents/FilterComponents";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {RequestTypeFilter} from "components/courierSupportRequestsPage/components/RequestTypeFilter";
import {ShiftRequestStatusFilter} from "components/courierSupportRequestsPage/components/ShiftRequestStatusFilter";
import React from "react";

const RequestTableFilters = ({filters = {}, handleUpdateFilters = () => {}}) => {
    const hasDateValue = filters?.startDate || filters?.endDate;
    const dateRangeValue = hasDateValue
        ? [filters?.startDate || null, filters?.endDate || null]
        : null;

    return (
        <VFlex gap={16} style={{marginBottom: "20px"}}>
            <VFlex vertical>
                <DateRangeFilter
                    label="Tarih Aralığı"
                    value={dateRangeValue}
                    onChange={value =>
                        handleUpdateFilters({
                            startDate: value?.[0] || null,
                            endDate: value?.[1] || null
                        })
                    }
                />
            </VFlex>
            <VFlex vertical>
                <h5>Talep Türü</h5>
                <RequestTypeFilter
                    value={
                        !filters?.type && !filters?.subType
                            ? "all"
                            : filters?.type === "support"
                            ? "support"
                            : filters?.subType
                    }
                    onChange={value => {
                        if (value === undefined || value === null || value === "all") {
                            handleUpdateFilters({
                                type: undefined,
                                subType: undefined
                            });
                        } else {
                            handleUpdateFilters({
                                type: value === "support" ? "support" : "planning",
                                subType: value === "support" ? undefined : value
                            });
                        }
                    }}
                />
            </VFlex>
            <VFlex vertical>
                <h5>Durum</h5>
                <ShiftRequestStatusFilter
                    value={filters?.status}
                    onChange={value => handleUpdateFilters({status: value || undefined})}
                    allowClear={true}
                    showLabel={false}
                    marginBottom="0px"
                    placeholder="Durum Seç"
                    style={{minWidth: "150px"}}
                />
            </VFlex>
        </VFlex>
    );
};

export default RequestTableFilters;
